<template>
  <v-card max-width="350px" class="d-flex pa-3" width="100%">
    <div class="d-flex flex-grow-1 flex-column justify-space-between">
      <span class="body-1 title-color">{{ title }}</span>
      <div class="d-flex flex-row justify-space-between align-center">
        <span class="text-h6">{{ valueString }}</span>
        <div class="d-flex align-center">
          <span :class="`${incrementValues.color}--text`">{{ increment }}%</span>
          <v-icon :color="incrementValues.color" class="pb-1">{{ incrementValues.icon }}</v-icon>
        </div>
      </div>
    </div>
    <div class="ml-3">
      <v-avatar sright size="55" color="primary">
        <v-icon :size="iconSize" color="white">{{ icon }}</v-icon>
      </v-avatar>
    </div>
  </v-card>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class KpiCard extends Vue {
  @Prop(String) title;

  @Prop(Number) value;

  @Prop({ Boolean, default: false }) isCurrencyUnit;

  @Prop({ String, default: '' }) unit;

  @Prop({ String, default: 'right' }) unitPosition;

  @Prop(Number) increment;

  @Prop(String) icon;

  @Prop({ type: Number, default: 22 }) iconSize;

  get valueString() {
    if (this.isCurrencyUnit) {
      if (this.unitPosition === 'right') {
        return `${this.value.toLocaleString()}${this.unit}`;
      }
      return `${this.unit}${this.value.toLocaleString()}`;
    }
    return `${this.value} ${this.unit}`;
  }

  get incrementValues() {
    const incrementConfig = { icon: 'mdi-arrow-up-bold', color: 'green' };
    if (this.increment < 0) {
      incrementConfig.icon = 'mdi-arrow-down-bold';
      incrementConfig.color = 'red';
    }
    return incrementConfig;
  }
}
</script>

<style scoped lang="css">
.title-color{
  color: #5c5c5c;
}

</style>
